import React from "react";
import "./ServiceSpotlight.css";

function ServiceSpotlight() {
  return (
    <div className="service-spotlight">
      <div className="content">
        <h3>Elevate your Business Today</h3>
        <p>Individualized solutions catered to the particular requirements</p>
      </div>
    </div>
  );
}

export default ServiceSpotlight;
